import React from 'react';
import PropTypes from 'prop-types';
import './instanceButton.css';

const InstanceButton = (props) => {

  const {
    addToMonitoring,
    chosenLabel,
    instance,
    monitoring,
    removeFromMonitoring,
  } = props;

  let monitored = false;

  if (monitoring.find(monitoredInstance => monitoredInstance.InstanceId === instance.InstanceId)) {
    monitored = true;
  };

  // Adds and removes an instance from monitoring.
  const handleClick = () => {
    if (!monitored) addToMonitoring(instance);
    else removeFromMonitoring(instance);
  };

  return (
    <div className="InstanceButton">
      <button className={monitored ? 'MonitoredInstanceButton' : 'UnmonitoredInstanceButton'} onClick={handleClick}>{instance[chosenLabel]}</button>
    </div>
  );

};

InstanceButton.propTypes = {

};

export default InstanceButton;


// WEBPACK FOOTER //
// ./src/components/content/instanceScreenshotViewer/sidebar/client/instanceButton/instanceButton.js